import styled from 'styled-components';
import { DATEPICKER_RANGE, DATEPICKER_RANGE_2MONTHS } from '../../util/data-id';

export const DatepickerWrapper = styled('div')`
  display: flex;
  align-items: top;
  justify-content: space-between;  
  border-radius: ${(props) => props.theme.radius.default};  
  & > div {
    display: flex;
    flex-wrap: wrap;
    background: white;
    width: 100%;
    border-radius: ${(props) => props.theme.radius.default};
    .react-datepicker {
      width: 100%;
      height: 100%;      
      border-radius: ${(props) => props.theme.radius.default};
    }
  }
  .react-datepicker {
    display: flex;
    justify-content: center;
    .react-datepicker__header {
      border-bottom: none;
      background: white;
      .react-datepicker__day-names {
        margin: 5px 0 0;
        .react-datepicker__day-name {
          color: ${(props) => props.theme.colors.muted};
        }
      }
    }
    .react-datepicker__day {
      border: 1px solid ${(props) => props.theme.colors.light};
      border-radius: 0;
    }
    .react-datepicker__day--disabled {
      opacity: 0.5;
    }       
  }
  .react-datepicker.${DATEPICKER_RANGE} {
    .react-datepicker__month-container {
      width: 100%;
    }
  }
  .react-datepicker.${DATEPICKER_RANGE_2MONTHS} {
    .react-datepicker__month-container {
      width: 50%;
    }
  }
  .react-datepicker.${DATEPICKER_RANGE},
  .react-datepicker.${DATEPICKER_RANGE_2MONTHS} {
    .react-datepicker__month-container {
      .react-datepicker__header .react-datepicker__day-names,
      .react-datepicker__month .react-datepicker__week {
        display: flex;        
      }
      .react-datepicker__day-name, .react-datepicker__day {
        flex: 1;
      }
    }
  }
`;
